"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tooltipContainerTemplate = exports.tooltipTemplate = void 0;
var tslib_1 = require("tslib");
var tooltip_dot_1 = (0, tslib_1.__importDefault)(require("./tooltip.dot"));
var tooltipContainer_dot_1 = (0, tslib_1.__importDefault)(require("./tooltipContainer.dot"));
var tooltipTemplate = tooltip_dot_1.default.default ? tooltip_dot_1.default.default : tooltip_dot_1.default;
exports.tooltipTemplate = tooltipTemplate;
var tooltipContainerTemplate = tooltipContainer_dot_1.default.default
    ? tooltipContainer_dot_1.default.default
    : tooltipContainer_dot_1.default;
exports.tooltipContainerTemplate = tooltipContainerTemplate;
//# sourceMappingURL=index.js.map